import { ChangeDetectionStrategy, Component, InputSignal, Signal, computed, input } from '@angular/core';

import { IBlock, siteHtmlOf, titledOfContent } from '@rt-tools/cms-contract';
import { BlockDirective, ElemDirective } from '@rt-tools/core';

const BEM_BLOCK: string = 'sc-blog-accordion-block';

@Component({
    selector: 'sc-blog-accordion-block',
    templateUrl: './blog-accordion-block.component.html',
    styleUrl: './blog-accordion-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // rt-tools
        BlockDirective,
        ElemDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class BlogAccordionBlockComponent {
    protected readonly item: Signal<IBlock.Content.Accordion> = computed(() => {
        const titled: IBlock.Content.Note = titledOfContent(this.content());
        return { ...titled, text: siteHtmlOf(titled.text) };
    });

    /** Содержимое блока аккордеона: заголовок и HTML текста. */
    public readonly content: InputSignal<string> = input.required<string>();
}
